export enum ReferenceSubmissionTypes {
	Education = 1,
	Professional = 2,
	Character = 3,
	Factual = 4,
	Academic = 5,
	Volunteer = 6,
}

export enum ReferenceSubmissionStatus {
	Requested = 1,
	Submitted = 2,
	Expired = 3,
}

export enum ReferenceChaseFrequency {
	Daily = 1,
	Custom = 2,
	Off = 3,
}

export enum ReferenceChaseCustomDay {
	Mon = 1,
	Tue = 2,
	Wed = 3,
	Thu = 4,
	Fri = 5,
}
